import Application from "./application"
import { trackEvent } from "./utilities/index"
import Overlay from "./overlay"

let Intro = function (params) {
	// console.log('Intro initalizing ' + params);

	/**
	 *
	 */
	let self = this
	let IntroElement = document.getElementById("intro")
	let content = IntroElement.querySelector(".content")
	let contentImage = IntroElement.querySelector(".content-image")
	let contentCTA = IntroElement.querySelector(".content-cta")
	let startButton = IntroElement.querySelector(".start-button")
	let introTitle = IntroElement.querySelector(".content-header")
	let timeline
	let overlay = new Overlay()

	this.open = function () {
		TweenLite.set([introTitle, contentCTA, contentImage], { opacity: 0 })
		content.style.display = "block"
		IntroElement.style.display = "block"
		timeline = new TimelineLite()
		timeline.to(IntroElement, Application.tweenLength, { opacity: 1 })
		timeline.to(introTitle, Application.tweenLength, { opacity: 1 })
		//timeline.to(contentImage, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.to(contentCTA, Application.tweenLength, { opacity: 1 }, Application.tweenStagger)
		timeline.play()
		startButton.addEventListener("click", self.startButtonClicked)

		// temp
		// overlay.setCompareIrons('t200', 't350');
		// overlay.openCompareOverlay();
	}

	this.startButtonClicked = function (event) {
		// console.log('Intro.startButtonClicked');
		self.close()
		trackEvent("intro", "start")
	}

	this.close = function () {
		// console.log('close ' + self);
		startButton.removeEventListener("click", self.startButtonClicked)
		timeline.kill()
		timeline = new TimelineLite({ onComplete: closeComplete })
		timeline.to(contentCTA, Application.tweenLength, { opacity: 0 })
		//timeline.to(contentImage, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(introTitle, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.to(IntroElement, Application.tweenLength, { opacity: 0 }, Application.tweenStagger)
		timeline.timeScale(1.5)
		timeline.play()
	}

	function closeComplete() {
		// console.log('closeComplete ' + self);
		timeline.kill()
		timeline = null
		content.style.display = "none"
		IntroElement.style.display = "none"
		window.driverSelector.introClosed()
	}
}

export default Intro
